"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addressBook = void 0;
var index_1 = require("./polygon/index");
var index_2 = require("./bsc/index");
var index_3 = require("./avax/index");
var index_4 = require("./fantom/index");
var index_5 = require("./heco/index");
exports.addressBook = {
    polygon: index_1.polygon,
    bsc: index_2.bsc,
    avax: index_3.avax,
    fantom: index_4.fantom,
    heco: index_5.heco,
};
